import processsearchresults from '../../_utilities/processsearchresults';
import recursiveLanguageResolve from '../../_utilities/recursive-language-resolve';

(() => {
  const reducer = () => (state, action) => {
    switch (action.type) {
      case 'UPDATE':
        state.items = action.value;
        break;
      default:
        break;
    }
    return state;
  };

  window.swinger.app({
    type: 'recommendations',
    component: 'slider',
    reducer: reducer(),
  })
    .then((app) => {
      const { language } = window.swinger.config;
      const state = app.store.getState();
      let failed = false;
      const retrieve = () => {
        const url = new URL(window.location);
        const params = url.searchParams;
        const itemsPerPage = params.get('count') || 12;
        let componentName = 'card-movie';
        let keyName = 'movies';
        let apiUrl = `${window.swinger.config.apiBase}${window.swinger.config.apiRoutes.searchMovies}?itemsPerPage=${itemsPerPage}&order=popularity`;

        if (!failed) {
          let search = state.search || 'from=any';

          if (window.swinger.config.environment && window.location.search && window.location.search.indexOf('from=') > -1) {
            search = window.location.search.substring(1);
          }

          if (
            window.swinger.config.hasScenes
          && search.indexOf('type=scenes') > -1
          ) {
            apiUrl = `${window.swinger.config.apiBase}${window.swinger.config.apiRoutes.recommendScenes}?${search}`;
            componentName = 'card-scene';
            keyName = 'scenes';
          } else {
            apiUrl = `${window.swinger.config.apiBase}${window.swinger.config.apiRoutes.recommendMovies}?${search}`;
          }

          if (state.kind) {
            componentName = `card-${state.kind}`;
            keyName = `${state.kind}s`;
            const apiRouteKey = `recommend${keyName.charAt(0).toUpperCase()}${keyName.slice(1)}`;
            console.log(componentName, apiRouteKey);
            apiUrl = `${window.swinger.config.apiBase}${window.swinger.config.apiRoutes[apiRouteKey]}?${search}`;
          }
        }

        window.swinger
          .ajax(apiUrl, {
            headers: {
              'Accept-Language': language,
            },
          })
          .then((result) => {
            const items = recursiveLanguageResolve(processsearchresults(result[keyName].slice(0, itemsPerPage)), language);

            if (!items.length) {
              return;
            }
            app.store.dispatch({
              type: 'UPDATE',
              value: items.map((item) => ({
                component: componentName,
                data: item,
              })),
            });
          })
          .catch((e) => {
            if (e) {
              console.error(e);
            }
            if (!failed) {
              failed = true;
              retrieve();
            }
          });
      };
      let lastAuthStatus = window.swinger.user.isLoggedIn();
      let initialized = false;
      const init = () => {
        const isLoggedIn = window.swinger.user.isLoggedIn();
        if (isLoggedIn === lastAuthStatus && initialized) {
          return;
        }
        lastAuthStatus = window.swinger.user.isLoggedIn();
        if (!isLoggedIn && state.authRequired) {
          return;
        }
        retrieve();
        initialized = true;
      };
      document.addEventListener('swinger.user:authchange', () => {
        init();
      });
      init();
    })
    .catch(console.info);
})();



// WEBPACK FOOTER //
// ./src/widgets/recommendations/recommendations.js